import { Reveal } from "../components/Reveal";
import { PricingSection } from "../components/PricingSection";

export default function PricingPage() {
  return (
    <div className="pt-28 md:pt-32 px-5 md:px-10 pb-10 md:pb-16">
      <div className="max-w-[1440px] mx-auto">
        <PricingSection />
        <Reveal>
          <p className="mt-8 text-center text-sm text-[#7F92AE] max-w-2xl mx-auto" data-testid="pricing-note">
            All prices are fixed — no hidden fees. Payment via bank transfer (UK) or Wise (international).
          </p>
        </Reveal>
      </div>
    </div>
  );
}
